// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IDocumentDetailApi,
  IDocumentDetailApiRequest,
  IDocumentDetailApiGetDropdownAttrs,
  IDocumentDetailApiGetDropdownResponse,
} from 'interfaces/back-office/master/document-detail/document-detail-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class DocumentDetailApi extends BaseApi<IDocumentDetailApi> implements IDocumentDetailApiRequest {
  readonly url = ApiConstant.MASTER_DOCUMENT_DETAIL_URL
  private documentDetailUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get document detail dropdown
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IDocumentDetailApiGetDropdownAttrs} payload
   *
   * @return {Promise<IDocumentDetailApiGetDropdownResponse>} Promise<IDocumentDetailApiGetDropdownResponse>
   */
  async documentDetail_getDocumentDetailDropdown(
    payload: IDocumentDetailApiGetDropdownAttrs,
  ): Promise<IDocumentDetailApiGetDropdownResponse> {
    try {
      const response = await this.POST(`${this.documentDetailUrl}/dropdown`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
